import React from 'react';
import { BridgeWaterPercentageSVG } from "./BridgeWaterPercentageSVG";

export const BridgeWaterSVG = ({
    fillColor,
    borderColor,
    contrastColor,
    backgroundColor,
    percent = 0
}) => {
    return (
        <BridgeWaterPercentageSVG
            fillColor={fillColor}
            borderColor={borderColor}
            contrastColor={contrastColor}
            backgroundColor={backgroundColor}
            percent={percent}
        />
    );
};